// src/components/Modal.js
import React from 'react';
import styles from './Modal.module.css';

function Modal({ title, message, actions, onClose }) {
  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        {title && <h3>{title}</h3>}
        {message && <p>{message}</p>}
        {actions && actions.length > 0 && (
          <div className={styles.modalActions}>
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                className={action.className || ''} // Use provided className or empty string
              >
                {action.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;
